
import Vue from 'vue';
import * as filters from '@/filters';
import './styles/index.css';
import config from './config';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './component';
import utils from '@/utils';
// require('./utils/qrcode');
Vue.use(Antd);
Vue.prototype.$config = config;
Vue.config.productionTip = false;
Vue.prototype.$utils = utils;

Object.keys(filters).map(item => Vue.filter(item, filters[item]));

/**
 * 移动端动态设置html根元素字体大小
 * */
// (() => {
//   const resize = () => {
//     const width = document.documentElement.clientWidth;
//     const size = Math.max(320, Math.min(width, 640)) / 16;
//     document.documentElement.style.fontSize = `${size}px`;
//   };
//   window.onresize = resize;
//   resize();
// })();



// WEBPACK FOOTER //
// ./src/app.js